export interface ServerConfig {
  port?: number;
  host?: string;
  apiPrefix?: string;
}

export interface FileInfo {
  path: string;
  content: string;
  stats: {
    size: number;
    modified: Date;
  };
}

export interface ScanOptions {
  paths?: string[];
  include?: string[];
  exclude?: string[];
}

export interface ScanProgress {
  current: number;
  total: number;
  currentPath: string;
  filesFound: number;
}

export interface TaskScanResult {
  files: number;
  tasks: number;
  duration: number;
}

export interface APIResponse<T = any> {
  success: boolean;
  data?: T;
  error?: string;
}

export interface ErrorResponse {
  error: string;
  code?: string;
  details?: any;
}

export interface CacheEntry<T> {
  data: T;
  timestamp: number;
  ttl: number;
}

// RateLimitInfo is exported from security/rate-limiter.ts